import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'B2C';

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed:', error);
});
